import { getJSON, getHrefParam, HOME_HOST } from './ultile';
import globalConfig from '@utiles/globalConfig';
const CONFIG_SKIN = 'skin/getSkin';

export const SET_CONFIG_SKIN_DATA = 'setConfigSkinData';
export const SET_PASSPORT_SKIN = 'setPassportSkin';
export const SET_SUPPORT_SKIN = 'setSupportSkin';
export const GET_SKIN = 'getSkin';
/**
 * SCREEN_TYPE，屏幕类型：1横屏，2竖屏
 * STYLE，样式,0通用，1浅色，2深色，3頑星playplanet（亮色），4 OMNIKADE（亮色）
 * 亮色：
 * （1）页面和弹窗背景色：#efeff1
 * （2）相关元素背景色： #ffffff
 * （3）间隔和边框线：#c6c6c6
 *
 * 暗色：
 * （1）页面和弹窗背景色：#313035
 * （2）相关元素背景色： #3d3c42
 * （3）间隔和边框线：#3d3c42
 */

const isWhiteSkin = style => {
  return [0, 1, 3, 4].includes(Number(style));
};

export default {
  state: {
    configSkinData: null
  },
  mutations: {
    [SET_CONFIG_SKIN_DATA](state, data) {
      state.configSkinData = data;
    },
    // 设置用户中心皮肤
    [SET_PASSPORT_SKIN](_state, data) {
      const fixedConfigTheme = {
        // 亮色皮肤
        white: {
          pageBgColor: '#efeff1',
          blockBgColor: '#ffffff',
          blockBgLightColor: '#ffffff',
          borderColor: '#c8c8c8',
          backColor: '#474747',
          textColor: '#474747',
          placeholderColor: '#989898',
          textOnMainBgColor: '#ffffff'
        },
        // 暗色皮肤
        black: {
          pageBgColor: '#313035',
          blockBgColor: '#111113',
          blockBgLightColor: '#3d3c41',
          borderColor: '#3d3c41',
          backColor: '#ffffff',
          textColor: '#ffffff',
          placeholderColor: '#818085',
          textOnMainBgColor: '#ffffff'
        }
      };

      // 通用皮肤默认配置
      const defaultConfigTheme = {
        mainColor: '#5CAFFF',
        menuItemTopBgColor: '#E9F3FE',
        menuItemBottomBgColor: '#ffffff',
        warningColor: '#5CAFFF',
        dangerColor: '#ff5b5b',
        menuItemIconColor: '#474747',
        hadBgTextColor: '#ffffff'
      };

      const defaultConfigBg = {
        'user_center_bg.png': require('@assets/image/sdkSkin/user_center_bg.png'),
        'popup_bg.png': require('@assets/image/sdkSkin/popup_bg.png'),
        'user_icon.png': require('@assets/image/sdkSkin/user_icon.png')
      };

      let applyFixedTheme = fixedConfigTheme.white;
      let applyConfigTheme = defaultConfigTheme;
      let applyConfigBg = defaultConfigBg;
      if (
        Object.prototype.toString.call(data?.THEME_COLOR) ===
          '[object Object]' &&
        Object.prototype.toString.call(data?.PIC_URL_LIST) === '[object Object]'
      ) {
        applyFixedTheme = isWhiteSkin(data.STYLE)
          ? fixedConfigTheme.white
          : fixedConfigTheme.black;
        applyConfigTheme = data.THEME_COLOR;
        applyConfigBg = data.PIC_URL_LIST;
      }

      // 默认主题色
      const themeConfig = {
        // 图片背景
        '--menu-bg': `url(${applyConfigBg['user_center_bg.png']})`, // 菜单背景
        '--modal-bg': `url(${applyConfigBg['popup_bg.png']})`, // 弹窗背景
        // 头像图片，优先使用配置的图片，如果没有配置，则使用默认图片
        '--avatar-bg': `url(${applyConfigBg['user_icon.png'] || defaultConfigBg['user_icon.png']})`, // 头像

        // 皮肤色系：颜色是固定二选一的
        '--page-bgColor': applyFixedTheme.pageBgColor, // ok弹窗和页面背景色，根据themeColor决定，非颜色配置
        '--block-bg-color': applyFixedTheme.blockBgColor,
        '--block-bg-light-color': applyFixedTheme.blockBgLightColor, // ok元素亮暗色系，根据themeColor决定，非颜色配置
        '--border-color': applyFixedTheme.borderColor, // ok间隔或边框颜色
        '--back-color': applyFixedTheme.backColor, // 返回按钮，下拉框箭头，菜单跳转图标颜色
        '--text-color': applyFixedTheme.textColor, // 常规文字颜色
        '--placeholder-color': applyFixedTheme.placeholderColor, // placeholder颜色
        '--text-on-main-bg-color': applyFixedTheme.textOnMainBgColor,

        // 全局主色
        '--main-color': applyConfigTheme.mainColor, // ok主调色
        // 文字颜色
        '--warning-color': applyConfigTheme.warningColor, // ok警示性颜色
        '--danger-color': applyConfigTheme.dangerColor, // ok危险性颜色
        // 主菜单颜色
        '--menu-item-top-bgColor': applyConfigTheme.menuItemTopBgColor, // 主菜单：上部分图标的背景色
        '--menu-item-bottom-bgColor': applyConfigTheme.menuItemBottomBgColor, // 主菜单：下部分字体的背景色
        '--menu-item-icon-color': applyConfigTheme.menuItemIconColor, // 主菜单：ok图标颜色
        // ok有背景图的的文字颜色
        '--had-bg-textColor': applyConfigTheme.hadBgTextColor
      };

      let cssStr = ':root{';
      for (let key in themeConfig) {
        cssStr += `${key}: ${themeConfig[key]};`;
      }
      cssStr += '}';
      const styleEle = document.createElement('style');
      styleEle.innerHTML = cssStr;
      document.head.appendChild(styleEle);
    },
    // 设置客服工单皮肤
    [SET_SUPPORT_SKIN](_state, data) {
      const fixedConfigTheme = {
        // 亮色皮肤
        white: {
          pageBgColor: '#f2f4f9',
          blockBgColor: '#ffffff',
          blockBgLightColor: '#ffffff',
          borderColor: '#c8c8c8',
          backColor: '#333333',
          textColor: '#333333',
          placeholderColor: '#999999',
          textOnMainBgColor: '#ffffff'
        },
        // 暗色皮肤
        black: {
          pageBgColor: '#313035',
          blockBgColor: '#111113',
          blockBgLightColor: '#3d3c41',
          borderColor: '#3d3c41',
          backColor: '#ffffff',
          textColor: '#ffffff',
          placeholderColor: '#818085',
          textOnMainBgColor: '#ffffff'
        }
      };

      // 通用皮肤默认配置
      const defaultConfigTheme = {
        mainColor: '#498CFF',
        menuItemTopBgColor: '#E9F3FE',
        menuItemBottomBgColor: '#ffffff',
        warningColor: '#5CAFFF',
        dangerColor: '#ff5b5b',
        menuItemIconColor: '#474747',
        hadBgTextColor: '#ffffff'
      };

      const defaultConfigBg = {
        'user_center_bg.png': require('@assets/image/sdkSkin/user_center_bg.png'),
        'popup_bg.png': require('@assets/image/sdkSkin/popup_bg.png'),
        'user_icon.png': require('@assets/image/sdkSkin/user_icon.png')
      };

      let applyFixedTheme = fixedConfigTheme.white;
      let applyConfigTheme = defaultConfigTheme;
      let applyConfigBg = defaultConfigBg;
      if (
        Object.prototype.toString.call(data?.THEME_COLOR) ===
          '[object Object]' &&
        Object.prototype.toString.call(data?.PIC_URL_LIST) === '[object Object]'
      ) {
        applyFixedTheme = isWhiteSkin(data.STYLE)
          ? fixedConfigTheme.white
          : fixedConfigTheme.black;
        applyConfigTheme = data.THEME_COLOR;
        applyConfigBg = data.PIC_URL_LIST;
      }

      // 默认主题色
      const themeConfig = {
        // 图片背景
        '--menu-bg': `url(${applyConfigBg['user_center_bg.png']})`, // 菜单背景
        '--modal-bg': `url(${applyConfigBg['popup_bg.png']})`, // 弹窗背景
        // 头像图片，优先使用配置的图片，如果没有配置，则使用默认图片
        '--avatar-bg': `url(${applyConfigBg['user_icon.png'] || defaultConfigBg['user_icon.png']})`, // 头像

        // 皮肤色系：颜色是固定二选一的
        '--page-bgColor': applyFixedTheme.pageBgColor, // ok弹窗和页面背景色，根据themeColor决定，非颜色配置
        '--block-bg-color': applyFixedTheme.blockBgColor,
        '--block-bg-light-color': applyFixedTheme.blockBgLightColor, // ok元素亮暗色系，根据themeColor决定，非颜色配置
        '--border-color': applyFixedTheme.borderColor, // ok间隔或边框颜色
        '--back-color': applyFixedTheme.backColor, // 返回按钮，下拉框箭头，菜单跳转图标颜色
        '--text-color': applyFixedTheme.textColor, // 常规文字颜色
        '--placeholder-color': applyFixedTheme.placeholderColor, // placeholder颜色
        '--text-on-main-bg-color': applyFixedTheme.textOnMainBgColor,

        // 全局主色
        '--main-color': applyConfigTheme.mainColor, // ok主调色
        // 文字颜色
        '--warning-color': applyConfigTheme.warningColor, // ok警示性颜色
        '--danger-color': applyConfigTheme.dangerColor, // ok危险性颜色
        // 主菜单颜色
        '--menu-item-top-bgColor': applyConfigTheme.menuItemTopBgColor, // 主菜单：上部分图标的背景色
        '--menu-item-bottom-bgColor': applyConfigTheme.menuItemBottomBgColor, // 主菜单：下部分字体的背景色
        '--menu-item-icon-color': applyConfigTheme.menuItemIconColor, // 主菜单：ok图标颜色
        // ok有背景图的的文字颜色
        '--had-bg-textColor': applyConfigTheme.hadBgTextColor
      };

      let cssStr = ':root{';
      for (let key in themeConfig) {
        cssStr += `${key}: ${themeConfig[key]};`;
      }
      cssStr += '}';
      const styleEle = document.createElement('style');
      styleEle.innerHTML = cssStr;
      document.head.appendChild(styleEle);

      // 把皮肤配置也发送给父页面webOfficialSupport
      window.parent.postMessage(
        {
          action: 'setSkinStyle',
          value: cssStr
        },
        '*'
      );
    }
  },
  actions: {
    [GET_SKIN]({ commit }, pageType) {
      // TODO:DEV
      // commit(pageType, {
      //   STYLE: 0,
      //   THEME_COLOR: null,
      //   PIC_URL_LIST: null
      // });
      // return;

      const defaultConfig = {
        STYLE: 0,
        THEME_COLOR: null,
        PIC_URL_LIST: null
      };
      return getJSON(HOME_HOST + CONFIG_SKIN, {
        // TODO DEV:
        // gameId: 211,
        // packageName: 'xxx'
        // TODO:DEV
        // gameId: 191,
        // packageName: 'com.global.ztmslg.ios'
        // TODO:DEV
        // gameId: 321,
        // packageName: 'xxx'

        // 正式参数
        gameId: getHrefParam('gameId'),
        packageName: getHrefParam('packageName'),
        skinVersion: getHrefParam('skinVersion') // SDK皮肤版本号
      })
        .then(({ res }) => {
          const { result, data } = res;
          if (result == 1) {
            commit(pageType, data);
            commit(SET_CONFIG_SKIN_DATA, data);
          } else {
            // 使用默认皮肤
            commit(pageType, defaultConfig);
            commit(SET_CONFIG_SKIN_DATA, defaultConfig);
          }
        })
        .catch(err => {
          console.error(err);
          // 使用默认皮肤
          commit(pageType, defaultConfig);
          commit(SET_CONFIG_SKIN_DATA, defaultConfig);
        });
    }
  }
};
